<template>
  <div>

    <div class=" loading-search" v-if="loading">
      <div class="fa-3x text-center">
        <i class="fas fa-circle-notch fa-spin text-success" style=""></i>
      </div>
    </div>
    <!-- BEGIN breadcrumb -->
    <ol class="breadcrumb float-xl-end">
      <li class="breadcrumb-item"><a href="javascript:;">Reportes</a></li>
      <li class="breadcrumb-item"><a href="javascript:;">Ventas</a></li>
      <li class="breadcrumb-item active"><a href="javascript:;">Despachos</a></li>
    </ol>

    <h1 class="page-header">Despachos<small></small></h1>

    <form @submit.prevent="search">
      <div class="row">
        <div class="col-md-8">
          <div class="form-group row">

            <div class="col-md-3">
              <label class="col-form-label">Fecha inicial</label>
              <div class="input-group">
                <date-picker id="dateTimeInput" v-model="date" :config="options" />
                <label for="dateTimeInput" class="input-group-text">
                  <i class="fa fa-calendar"></i>
                </label>
              </div>
            </div>

            <div class="col-md-3">
              <label class="col-form-label">Fecha final</label>
              <div class="input-group">
                <date-picker id="dateTimeInputEnd" v-model="dateEnd" :config="options" />
                <label for="dateTimeInputEnd" class="input-group-text">
                  <i class="fa fa-calendar"></i>
                </label>
              </div>
            </div>

            <div class="col-md-3">
              <label class="col-form-label">Ciudad</label>
              <select class="form-select" @change="getEstaciones()" v-model="ciudadSelect"
                :disabled="deshabilitarCombos">
                <option v-for="ciudad in ciudades" :value="ciudad.Id" v-bind:key="ciudad.Id">
                  {{ ciudad.Nombre }}
                </option>
              </select>
            </div>
            <div class="col-md-3">
              <label class="col-form-label">Estación</label>
              <select class="form-select" v-model="estacionSelect" :disabled="deshabilitarCombos">
                <option value="">Seleccionar Estación</option>
                <option v-for="estacion in estaciones" :value="estacion.NoEstacion" v-bind:key="estacion.NoEstacion">
                  {{ estacion.Nombre }}
                </option>
              </select>
            </div>

          </div>
        </div>
        <div class="col-md-2">
          <button type="submit" class="btn btn-success me-1 mb-1" style="margin-top: 3.1em;" :disabled="!formValido">{{
            textoBotonBuscar
          }}</button>
        </div>
        <div class="col-md-2" style="padding-top: 2.7em;">

        </div>
      </div>
      <div class="row">
        <div class="col-12 mt-2" v-if="errorMsg" style="color:#c00">{{ errorMsg }}</div>
      </div>
    </form>
    <div>
      <panel title="Despachos" bodyClass="p-0" class="" style="margin-top: 15px;">
        <DxDataGrid id="gridContainer" :data-source="searchResult" key-expr="Transaccion" :show-borders="true"
          @exporting="onExporting" :show-column-lines="true" :show-row-lines="true" :row-alternation-enabled="true">

          <DxPaging :enabled="true" />
          <DxScrolling column-rendering-mode="virtual" />

          <DxFilterRow />
          <DxHeaderFilter :visible="showHeaderFilter" />
          <DxSearchPanel :visible="true" :width="240" placeholder="Search..." />

          <DxExport :enabled="true" :allow-export-selected-data="false" />
          <DxSelection mode="false" />

          <DxColumnFixing :enabled="true" />


          <DxColumn dataField="Transaccion" caption="Transacción" :width="100" />
          <DxColumn dataField="FechaVenta" caption="FechaVenta" dataType="date" format="dd/MM/yyyy" :width="120" />
          <DxColumn dataField="FechaCorte" caption="FechaCorte" dataType="date" format="dd/MM/yyyy" :width="120" />

          <DxColumn data-field="Cantidad" caption="Cantidad" data-type="number" alignment="right" :width="100">
            <DxFormat type="fixedPoint" :precision="2" />
          </DxColumn>

          <DxColumn data-field="Total" caption="Total" data-type="number" alignment="right" :width="100">
            <DxFormat type="currency" :precision="2" />
          </DxColumn>


          <DxColumn dataField="UUID" caption="UUID" :width="300" />
          <!-- <DxColumn dataField="Emisor" caption="Emisor" :width="300" /> -->
          <DxColumn dataField="Receptor" caption="Receptor" :width="300" />
          <DxColumn dataField="Folio" caption="Folio" :width="150" />

          <DxColumn dataField="Producto" caption="Producto" :width="300" />
          <DxColumn dataField="TipoPago" caption="TipoPago" :width="300" />

          <DxColumn dataField="Turno" caption="Turno" :width="100" />

          <DxColumn dataField="Bomba" caption="Bomba" :width="100" />



          <DxColumn caption="Acciones" cell-template="grid-cell-template" :width="100" :fixed="true"
            fixed-position="right" />

          <template #grid-cell-template="{ data }">
            <div class="text-center">
              <div class="row">
                <div class="col">
                  <i class="btn btn-success fas fa-file-alt btn-pointer" @click="openModalVisor(data)" alt="" width="10"
                    height="10" title="Ticket"></i>
                </div>
              </div>
            </div>
          </template>


        </DxDataGrid>
        <b-modal id="modalDialogVisor" size="xl" centered cancel-variant="default">
          <template slot="modal-header">
            <h4 class="modal-title">Visualizando Ticket</h4>
            <a class="btn-close" @click="$bvModal.hide('modalDialogVisor')"></a>
          </template>
          <div class="card">
            <object type="application/pdf" :data="Archivo.base64" width="100%" height="600px"></object>
          </div>

          <template #modal-footer>
            <div class="row">
              <div class="col">
                <b-button class="float-right" variant="primary" @click="$bvModal.hide('modalDialogVisor')">
                  Close
                </b-button>
              </div>
            </div>
          </template>

        </b-modal>
      </panel>
    </div>

    <!-- bottom left vue-notification -->
    <notifications group="top-right" position="top right" :speed="1000" />

  </div>
</template>

<script>

import axios from 'axios';
import moment from 'moment';



import { DxFormat, DxColumnFixing, DxDataGrid, DxPaging, DxScrolling, DxColumn, DxExport, DxSelection, DxHeaderFilter, DxFilterRow, DxSearchPanel, } from 'devextreme-vue/data-grid';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
// Our demo infrastructure requires us to use 'file-saver-es'. We recommend that you use the official 'file-saver' package in your applications.
import { exportDataGrid } from 'devextreme/excel_exporter';
//import service from './data.js';


var numeral = require("numeral");
import Vue from "vue";

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
Vue.filter("formatNumber", function (value) {
  return numeral(value).format("0,00.00"); // displaying other groupings/separators is possible, look at the docs
});

Vue.filter("currency", function (value) {
  return numeral(value).format("$0,0.00");
});


export default {
  mounted: function () {
    /* eslint-disable no-debugger */
    //debugger;
    var self = this;

    var userSetting = JSON.parse(localStorage.getItem('userSettings'));
    this.usuario = userSetting.Usuario;
    this.usuarioEstacion = userSetting.Estacion;
    this.IdRol = userSetting.IdRol;
    this.getCiudades();
    this.ciudadSelect = userSetting.CiudadId != 0 ? userSetting.CiudadId : 1;

    this.getEstaciones();
    this.estacionSelect = "";


    const hoy = moment()
    this.date = hoy.startOf('month').format('YYYY/MM/DD')
    this.dateEnd = hoy.format('YYYY/MM/DD')

    if (this.IdRol == 3 || this.IdRol == 7) {
      this.deshabilitarCombos = true;
    }

  },
  beforeCreate() {

  },
  created() {
    // console.log('created');
  },
  components: {
    DxFormat, DxColumnFixing, DxDataGrid, DxPaging, DxScrolling, DxColumn, DxExport, DxSelection, DxHeaderFilter, DxFilterRow, DxSearchPanel,
  },
  beforeMount() {
    // console.log('beforeMount');
  },
  computed: {
    formValido() {
      return this.validarRango()
    }
  },
  watch: {
    date() {
      this.ajustarRangoPorMes()
    },
    estacionSelect(val) {
      if (val && this.errorMsg === 'Debe seleccionar una Estación') {
        this.errorMsg = ''
      }
    }

  },
  methods: {
    ajustarRangoPorMes() {
      if (!this.date) return

      const seleccion = moment(this.date, 'YYYY/MM/DD')
      const hoy = moment()

      // Siempre forzamos la inicial al 1ro de ese mes
      const inicioMes = seleccion.clone().startOf('month')

      // ¿Ese mes es el mes actual?
      const esMesActual =
        seleccion.isSame(hoy, 'month') && seleccion.isSame(hoy, 'year')

      let finRango
      if (esMesActual) {
        // Si es el mes actual, la fecha final es hoy
        finRango = hoy
      } else {
        // Si es otro mes, último día del mes seleccionado
        finRango = seleccion.clone().endOf('month')
      }

      this.date = inicioMes.format('YYYY/MM/DD')
      this.dateEnd = finRango.format('YYYY/MM/DD')
      this.errorMsg = ''   // por si había error previo
    },
    validarRango() {
      // limpia mensaje anterior
      this.errorMsg = ''

      if (!this.date || !this.dateEnd) return false

      const a = moment(this.date, 'YYYY/MM/DD')   // fecha inicial
      const b = moment(this.dateEnd, 'YYYY/MM/DD') // fecha final

      // 1) Fecha final menor a inicial
      if (b.isBefore(a, 'day')) {
        this.errorMsg = 'La fecha final no puede ser menor a la fecha inicial.'
        return false
      }

      // 2) Año diferente
      if (!a.isSame(b, 'year')) {
        this.errorMsg = 'La fecha final no puede ser de un año distinto al de la fecha inicial.'
        return false
      }

      // 3) Mes diferente (aquí va lo que pediste)
      if (!a.isSame(b, 'month')) {
        const finMesInicial = a.clone().endOf('month')
        this.errorMsg = `La fecha final no puede ser mayor al último día del mes de la fecha inicial. El rango máximo permitido es del ${a.format('YYYY/MM/DD')} al ${finMesInicial.format('YYYY/MM/DD')}.`
        return false
      }

      // Si todo OK
      return true
    },

    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('Despachos');

      exportDataGrid({
        component: e.component,
        worksheet: worksheet,
        autoFilterEnabled: true
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Despachos.xlsx');
        });
      });
      e.cancel = true;
    },
    async getCiudades() {
      try {
        const response = await axios.get('Catalogos/GetCiudades');
        if (response.data.Success) {
          if (response.data.response.length == 0) {
            this.alertMessage = "No se encontró información.";
            this.alertTitle = "Error";
            this.show('top-right', 'error');
          }
        } else {
          console.log("error")
          this.alertMessage = response.data.Error;
          this.alertTitle = "Error";
          this.show('top-right', 'error');
        }
        this.ciudades = response.data.response;
      } catch (e) {
        //this.alert = true;
        //this.error = 'Invalid email/password';
      }
    },
    async getEstaciones() {
      try {
        const response = await axios.post('Estacion/GetEstaciones?ciudad=' + this.ciudadSelect);
        if (response.data.Success) {
          if (response.data.response.length == 0) {
            this.alertMessage = "No se encontró información.";
            this.alertTitle = "Error";
            this.show('top-right', 'error');
          }
        } else {
          console.log("error")
          this.alertMessage = response.data.Error;
          this.alertTitle = "Error";
          this.show('top-right', 'error');
        }
        this.estaciones = response.data.response;

        //debugger; // eslint-disable-line no-debugger
        // this.productos = [];
        // this.getProductos();
      } catch (e) {
        //this.alert = true;
        //this.error = 'Invalid email/password';
      }
    },
    show(group, type = '') {
      const text = this.alertMessage;
      this.$notify({
        group,
        title: this.alertTitle,
        text,
        type,
        data: {
          randomNumber: Math.random()
        }
      })
    },
    clean(group) {
      this.$notify({ group, clean: true })
    },
    swalNotification(swalType) {
      var btnClass = (swalType == 'error') ? 'danger' : swalType;
      btnClass = (swalType == 'question') ? 'primary' : btnClass;
      this.$swal({
        title: 'Are you sure?',
        text: 'You will not be able to recover this imaginary file!',
        type: swalType,
        showCancelButton: true,
        buttonsStyling: false,
        confirmButtonText: swalType.charAt(0).toUpperCase() + swalType.substr(1).toLowerCase(),
        cancelButtonText: 'Cancel',
        confirmButtonClass: 'btn me-5px btn-' + btnClass + '',
        cancelButtonClass: 'btn btn-default',
      })
    },

    async seachDespachos() {
      var self = this;

      self.textoBotonBuscar = "Buscando...";
      self.loading = true;
      try {
        //debugger;
        if (!this.formValido) {
          this.errorMsg = this.errorMsg || 'Corrige las fechas: la fecha inicial y final deben ser del mismo mes y año, y la fecha final no puede ser menor a la inicial.'
          self.loading = false;
          self.textoBotonBuscar = "Buscar";
          return
        }

        self.intDate = self.date.replace('/', '');
        self.intDate = self.intDate.replace('/', '');

        self.intDateEnd = self.dateEnd.replace('/', '');
        self.intDateEnd = self.intDateEnd.replace('/', '');

        if (self.estacionSelect == null || self.estacionSelect == "") {
          this.errorMsg = this.errorMsg || 'Debe seleccionar una Estación'
          self.loading = false;
          self.textoBotonBuscar = "Buscar";
          return
        }
        //var ciudad = self.ciudadSelect != undefined ? self.ciudadSelect : 0;
        var estacion = self.estacionSelect != undefined ? self.estacionSelect : 0;


        var dataToSend = {
          "Data": {
            "FechaIni": self.intDate,
            "FechaFin": self.intDateEnd,
            "Estacion": estacion,
          }
        };

        self.searchResult = [];

        const response = await axios.post('Despacho/GetDespachos  ', dataToSend);
        self.textoBotonBuscar = "Buscar";
        if (response.data.Success) {
          if (response.data.response.length == 0) {
            self.alertMessage = "No se encontró información del día especificado.";
            self.alertTitle = "Error";
            self.show('top-right', 'error');
          } else {

            // const data = response.data.response.map(item => ({
            //   ...item,
            //   Cantidad: item.Cantidad ? parseFloat(parseFloat(item.Cantidad).toFixed(2)) : 0,
            //   Total: item.Total ? parseFloat(parseFloat(item.Total).toFixed(2)) : 0,
            // }));

            self.searchResult = response.data.response;
          }
          self.loading = false;

        } else {
          console.log("error")
          self.alertMessage = response.data.Message;
          self.alertTitle = response.data.Error;
          self.show('top-right', 'error');
        }
        self.loading = false;
      } catch (e) {
        self.loading = false;
        self.alertMessage = "Error al consultar";
        self.alertTitle = 'Error';
        self.show('top-right', 'error');
        //this.alert = true;
        //this.error = 'Invalid email/password';
      }
    },
    async search(e) {

      e.preventDefault();
      this.seachDespachos();
    },
    async openModalVisor(data) {
      var self = this;

      self.loading = true;
      self.Archivo.base64 = "";

      try {

        var cardInfo = data.row.data;
        var ciudad = self.ciudadSelect != undefined ? self.ciudadSelect : 0;
        var estacion = self.estacionSelect != undefined ? self.estacionSelect : "";

        console.log(cardInfo);

        var dataToSend = {
          "Data": {
            "Estacion": estacion,
            "Transaccion": cardInfo.Transaccion,
            "Ciudad": ciudad
          }
        }

        const response = await axios.post('Despacho/GetTicketFull', dataToSend);

        this.$bvModal.show('modalDialogVisor');
        if (response.data.Success) {
          if (response.data.response.length == 0) {
            self.alertMessage = "No se encontró información especificada.";
            self.alertTitle = "Error";
            self.show('top-right', 'error');
          } else {
            var respuesta = response.data.response;
            self.Archivo.base64 = "data:application/pdf;base64," + respuesta.PDF;
            self.loading = false;
          }
        } else {
          console.log("error")
          self.alertMessage = response.data.Message;
          self.alertTitle = "Error";
          self.show('top-right', 'error');
          self.loading = false;
        }

        self.loading = false;
      } catch (e) {
        self.loading = false;
        self.alertMessage = e;
        self.alertTitle = "Error";
        self.show('top-right', 'error');
      }
    },
  },
  data() {
    return {
      fromCuadreDetalle: false,
      parametrosCuadre: null,
      showHeaderFilter: true,
      RespuestaCompras: [],
      loading: false,
      deshabilitarCombos: false,
      ciudades: [],
      estaciones: [],
      ciudadSelect: 1,
      estacionSelect: 0,
      intDateEnd: "",
      date: moment().format("YYYY/MM/DD"),
      dateEnd: moment().format("YYYY/MM/DD"),
      intDate: "",
      options: {
        format: 'YYYY/MM/DD',
        useCurrent: false,
        icons: {
          time: 'fa fa-clock',
          date: 'fa fa-calendar',
          up: 'fa fa-chevron-up',
          down: 'fa fa-chevron-down'
        }
      },
      pageUserSettings: {},
      alertMessage: "",
      alertTitle: "",
      searchResult: [],
      textoBotonBuscar: "Buscar",
      errorMsg: '',
      Archivo: {
        base64: '',
      },
      pdfBase64Resend: undefined,
    };
  }
}
</script>
<style scoped>
.dx-datagrid-header-panel {
  display: none !important;
}

.loading-search {
  position: absolute;
  width: 100%;
  left: 0px;
  height: 100%;
  background: rgba(0, 0, 0, 0.1);
  z-index: 1000;
  padding-top: 150px;
  top: 0;
}

.sumatoriasRow {
  background-color: #bbb;
}

.currencyRow {
  text-align: right !important;
}

.vgt-fixed-header {
  overflow-y: auto;
}

.vgt-table__header {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: #f5f5f5;
}

#gridContainer {
  height: 600px;
}
</style>